"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = validateRSAA;

var _every = _interopRequireDefault(require("lodash/every"));

var _forEach = _interopRequireDefault(require("lodash/forEach"));

var _isArray = _interopRequireDefault(require("lodash/isArray"));

var _isBoolean = _interopRequireDefault(require("lodash/isBoolean"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _isPlainObject = _interopRequireDefault(require("lodash/isPlainObject"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _isUndefined = _interopRequireDefault(require("lodash/isUndefined"));

var _includes = _interopRequireDefault(require("lodash/includes"));

var _overSome = _interopRequireDefault(require("lodash/overSome"));

var _RSAA = _interopRequireDefault(require("../constants/RSAA"));

var _isRSAA = _interopRequireDefault(require("./isRSAA"));

var _isValidTypeDescriptor = _interopRequireDefault(require("./isValidTypeDescriptor"));

var isValidType = (0, _overSome.default)([_isString.default, _isValidTypeDescriptor.default]);
var isValidShouldCallAPI = (0, _overSome.default)([_isUndefined.default, _isBoolean.default, _isFunction.default]);

function validateRSAA(action) {
  var validKeys = ['types', 'callAPI', 'shouldCallAPI'];
  var validationErrors = [];

  if (!(0, _isRSAA.default)(action)) {
    validationErrors.push('A RSAA action must be a plain object with a [RSAA] property');
    return validationErrors;
  }

  (0, _forEach.default)(action, function (value, key) {
    if (key !== _RSAA.default) {
      validationErrors.push("Invalid root key: ".concat(key));
    }
  });
  var props = action[_RSAA.default];

  if (!(0, _isPlainObject.default)(props)) {
    validationErrors.push('[RSAA] property must be a plain JavaScript object');
  }

  (0, _forEach.default)(props, function (value, key) {
    if (!(0, _includes.default)(validKeys, key)) {
      validationErrors.push("Invalid [RSAA] key: ".concat(key));
    }
  });

  if ((0, _isUndefined.default)(props.types)) {
    validationErrors.push('[RSAA] must have a types property');
  } else if (!(0, _isArray.default)(props.types) || props.types.length !== 3) {
    validationErrors.push('[RSAA].types property must be an array of length 3');
  } else if (!(0, _every.default)(props.types, isValidType)) {
    validationErrors.push('[RSAA].types property must be an array containing strings or plain object descriptors');
  }

  if ((0, _isUndefined.default)(props.callAPI)) {
    validationErrors.push('[RSAA] must have a callAPI property');
  } else if (!(0, _isFunction.default)(props.callAPI)) {
    validationErrors.push('[RSAA].callAPI property must be a function');
  }

  if (!isValidShouldCallAPI(props.shouldCallAPI)) {
    validationErrors.push('[RSAA].shouldCallAPI property must be undefined, a boolean, or a function');
  }

  return validationErrors;
}